<template>

    <div
        class="modal fade product-modal"
        :id="realId"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="'modallabel-product-' + product.id"
        aria-hidden="true"
    >
        <div
            class="modal-dialog"
            :class="['modal-' + size]"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header">
                    <div>
                        <h2 class="modal-title">{{ product.title }}</h2>
                        <h5 class="modal-subtitle">{{ product.sub_title }}</h5>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" :aria-label="__('redeem.close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="type==='pocket_pack' || type==='magazine_subscription'" class="modal-body">
                    <div class="row">
                        <div
                            class="col-12 col-md-8 order-2 order-md-1 mb-4"
                            :class="{ 'col-md-8': product.thumbnail, 'col-md-12': !product.thumbnail }"
                        >
                            <span v-if="product.author"><i>{{ __('redeem.author') }}: {{ product.author }}</i><br></span>
                            <span v-if="product.subscription"><i>{{ __('redeem.author') }}: {{ product.subscription }}</i><br></span>
                            <!--                            <span v-if="product.next_edition"><i>{{ __('redeem.next_edition') }}: {{ product.next_edition }}</i><br></span>-->
                            <span v-if="product.publisher"><i>{{ __('redeem.publisher') }}: {{ product.publisher }}</i><br></span>
                            <span v-if="product.publish_date"><i>{{ __('redeem.publish_date') }}: {{ product.publish_date }}</i><br></span>
                            <span v-if="product.genre"><i>{{ __('redeem.genre') }}: {{ product.genre }}</i><br></span>
                            <span v-if="product.isbn"><i>{{ __('redeem.isbn') }}: {{ product.isbn }}</i><br></span>
                            <span v-else-if="product.type==='pocket_pack'"><i>{{ __('redeem.format') }}: {{ __('redeem.pocket') }}</i><br></span>
                            <span v-if="product.no_of_issues"><i>{{ __('redeem.subscription_includes') }} {{ product.no_of_issues }} {{ __('redeem.numbers') }}</i><br></span>
                            <div v-if="type==='poster'" v-html="__('redeem.posters_category_desc')"></div>
                            <div style="margin-top: 10px;" v-html="product.description"></div>
                            <div
                                v-if="!chooseDisabled && !hideSelect && !hideButtons && !selected"
                                class="submit-button"
                            >
                                <button
                                    type="button"
                                    @click.prevent="selectGift"
                                    class="btn btn-primary btn-block btn-lg mt-4"
                                >{{ realChooseText }}</button>
                            </div>
                        </div>
                        <div v-if="product.thumbnail" class="col-12 col-md-4 order-1 order-md-2 mb-4 text-center">
                            <img alt="" :src="product.thumbnail" :style="{ maxWidth: (type==='poster' ? '220px' : '170px') }">
                        </div>
                    </div>
                </div>
                <div v-else class="modal-body">
                    <div class="row">
                        <div class="col-12 col-md-6 order-2 order-md-1 mb-4">
                            <div v-html="product.description"></div>
                            <div v-if="type==='poster'" v-html="__('redeem.posters_category_desc')"></div>
                            <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                                <img v-for="(icon, icon_index) in product.icons" :src="icon.url" :title="icon.text" style="max-width: 65px;" :key="'icon-' + icon_index">
                            </div>
                            <div
                                v-if="!chooseDisabled && !hideSelect && !hideButtons && !selected"
                                class="submit-button"
                            >
                                <button
                                    type="button"
                                    @click.prevent="selectGift"
                                    class="btn btn-primary btn-block btn-lg mt-4"
                                >{{ realChooseText }}</button>
                            </div>
                            <div v-if="type === 'products'">
                                <hr>
                                <h5 class="styled-header">{{ __('redeem.delivery_information') }}</h5>
                                <div v-if="product.product_category_id===102" class="mt-4">
                                    <p v-html="__('redeem.delivery_info.charity')"></p>
                                </div>
                                <div v-else-if="product.is_food==1">
                                    <img alt="" src='/_images/kylbox.jpg' style='height:92px; margin-top:10px;'>
                                    <p v-html="__('redeem.delivery_info.food')"></p>
                                </div>
                                <div v-else-if="product.is_virtual==1 || (product.allowed_deliv_types & 4) === 4">
                                    <p v-html="__('redeem.delivery_info.online')"></p>
                                </div>
                                <div v-else-if="product.allowed_deliv_types==='' || product.allowed_deliv_types===1" class="mt-4">
                                    <!--                                    <img alt="" src='/_images/leverans_box.jpg' style='height:92px;'>-->
                                    <p v-html="__('redeem.delivery_info.dpd')"></p>
                                </div>
                                <div v-else-if="(product.allowed_deliv_types & 2) === 2" class="mt-4">
                                    <!--                                    <img alt="" src='/_images/leverans_box.jpg' style='height:92px;'>-->
                                    <p v-html="__('redeem.delivery_info.postoffice')"></p>
                                </div>
                                <div v-if="(product.allowed_deliv_types & 8) === 8">
                                    <p v-html="__('redeem.delivery_info.postal')"></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 order-1 order-md-2 mb-4">
                            <div v-if="product.images.length">
                                <div :id="'image-carousel-' + uniqueId" class="carousel slide square-carousel" data-ride="carousel">
                                    <ol class="carousel-indicators">
                                        <li v-for="(image, i_index) in product.images" :key="i_index" :data-target="'#image-carousel-'+uniqueId" :data-slide-to="i_index" v-bind:class="{ 'active': i_index<1 }"></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div v-for="(image, i_index) in product.images" :key="i_index" class="carousel-item" v-bind:class="{ 'active': i_index<1 }">
                                            <img class="d-block w-100" :src="image" :alt="product.title">
                                        </div>
                                    </div>
                                    <a class="carousel-control-prev" :href="'#image-carousel-'+uniqueId" role="button" data-slide="prev">
                                        <div style="background-color: black; display: inline-block; border-radius: 3px; padding: 12px 7px 7px 7px;">
                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span class="sr-only">Previous</span>
                                        </div>
                                    </a>
                                    <a class="carousel-control-next" :href="'#image-carousel-'+uniqueId" role="button" data-slide="next">
                                        <div style="background-color: black; display: inline-block; border-radius: 3px; padding: 12px 7px 7px 7px;">
                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span class="sr-only">Next</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        product: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'lg',
        },
        chooseDisabled: {
            type: Boolean,
            default: false,
        },
        hideSelect: {
            type: Boolean,
            default: false,
        },
        hideButtons: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        chooseText: {
            type: String,
            default: null,
        },
    },
    methods: {
        selectGift() {
            this.$emit('select:gift');
        },
        open() {
            $('#' + this.realId).modal('show');
        },
    },
    computed: {
        realId() {
            return this.id ? this.id : 'modal-product-' + this.uniqueId;
        },
        uniqueId() {
            return this.product?.product_category_id + '-' + this.product.id + (this.product.subproduct_id ? '-' + this.product.subproduct_id : '');
        },
        realChooseText() {
            if (this.chooseText) {
                return this.chooseText;
            }
            if (this.type === 'poster') {
                return this.__('redeem.choose_this_poster');
            }
            if (this.type === 'pocket_pack') {
                return this.__('redeem.choose_this_book');
            }
            if (this.type === 'magazine_subscription') {
                return this.__('redeem.choose_this_magazine');
            }
            return this.__('redeem.choose_this_gift');
        },
    },
};
</script>
